const fillStyle = { fill: '#888' }

const EditDefault = ({className}) => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12.08 23.38" className={className}><g id="a"/><g id="b"><g id="c"><path id="d" style={fillStyle} d="M.03,18.03h-.03L6.59,3.27l4.25,1.9-6.59,14.75h-.03L.16,23.38,.03,18.03Z"/><path id="e" style={fillStyle} d="M9.38,.11l1.94,.87c.64,.28,.92,1.03,.64,1.67l-.82,1.83h0l-4.25-1.9h0l.82-1.83c.28-.64,1.03-.92,1.67-.64Z"/></g></g></svg>
    )
}

export default EditDefault
